import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  mapToModel,
  toModel,
  toModelArray,
} from '@kinet-open-network/client/shared/data-access/model';
import { downloadBlob } from '@kinet-open-network/client/shared/util';
import { IAttachment } from '@kinet-open-network/shared/data-access/model';
import { Observable, firstValueFrom, map } from 'rxjs';
import { Attachment } from './attachment.model';

@Injectable({
  providedIn: 'root',
})
export class AttachmentsService {
  private http = inject(HttpClient);

  getById(id: string): Observable<Attachment> {
    return this.http
      .get<{ data: IAttachment }>(`/attachments/${id}`)
      .pipe(mapToModel(Attachment, 'data'));
  }

  getByIds(ids: string[]): Observable<Attachment[]> {
    return this.http
      .get<{ data: IAttachment[] }>(`/attachments`, {
        params: { ids },
      })
      .pipe(map(({ data }) => toModelArray(data, Attachment)));
  }

  create(payload: {
    data: string;
    [key: string]: any;
  }): Observable<Attachment> {
    return this.http
      .post<{ data: IAttachment }>(`/attachments`, payload)
      .pipe(
        map(({ data: attachment }) =>
          toModel({ ...attachment, data: payload.data }, Attachment),
        ),
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`/attachments/${id}`);
  }

  async download(id: string, name: string | null) {
    return firstValueFrom(
      this.http.get(`/attachments/${id}/download`, {
        responseType: 'blob',
        observe: 'response',
      }),
    ).then((file) => {
      const blob = file.body as Blob;
      return downloadBlob(blob, name ?? 'download');
    });
  }
}
